<template>
  <div class="home">
    <DialogLegalAcceptance v-if="showLegal" @accepted="showLegal = false" />
    <div class="content">
      <div class="intro">
        <p>חברת BETTER WAY מתמחה בניהול דוחות חניה לרכבי ליסינג מסחריים, הסבה דיגיטלית של הדוחות ובהפחתת הקנסות המשולמים על ידי חברות הקצה לצד ניהול יעיל, חכם וחוסך זמנים של צי רכבי החברה וטיפול בתאונות ונזקי רכב, על ידי קצין הבטיחות בתעבורה בחברה.</p>
        <p>
          BETTER WAY
          הינה מערכת מושתתת WEB,
          המאפשרת לך גישה
          נוחה מכל מקום ובכל שעה, גם באמצעות אפליקציה התומכת במובייל. הורדת האפליקציה לנייד, תאפשר שיוך כל נהג לרכב חברה, זיהוי מיקומו בזמן אמת ושליחת הודעות.
        </p>
      </div>
      <div class="what-we-do">
        <h1>מה אנחנו עושים</h1>
      </div>
      <div class="items">
        <div class="item">
          <img src="/images/icon-round.svg" alt />
          אחריות מלאה על פיגורים בתשלום הדוחות
        </div>
        <div class="item">
          <img src="/images/icon-money.svg" alt />
          התראה לקצין הבטיחות בתעבורה על קבלת דוח החניה
        </div>
        <div class="item">
          <img src="/images/icon-phone.svg" alt />
          ממשק פשוט ומהיר להסדרת תשלום כל דוחות החניה הפתוחים בפעולה אחת
        </div>
        <div class="item">
          <img src="/images/icon-eye.svg" alt />
          בקרה ומעקב אחר סטטוס דוחות החניה החל ממועד הנפקתם
        </div>
        <div class="item">
          <img src="/images/icon-money2.svg" alt />
          איסוף הדוחות במרוכז מכלל הרשויות ברמה ארצית
        </div>
        <div class="item">
          <img src="/images/icon-crush.svg" alt />
          הגשת דוחות תאונה מיידים מלווים בתמונות מתוך האפליקציה
        </div>
        <div class="item">
          <img src="/images/icon-route.svg" alt />
          בחינת מהימנות הדוחות ומיקום הנפקתם למול מסלול נסיעת הרכב והתראה על דוחות לא תקינים
        </div>
        <div class="item">
          <img src="/images/icon-route.svg" alt />
          הסבת דוחות חניה מול כל העיריות
        </div>
        <div class="item">
          <img src="/images/icon-route.svg" alt />
          הסבת דוחות משטרה
        </div>
        <div class="item">
          <img src="/images/icon-route.svg" alt />
          ניהול החשבון בכבישי אגרה
        </div>
      </div>
    </div>
    
    <div class="app-section">
      <h1 class="app-betterway-title">אפליקציית BetterWay</h1>
      <div class="app-buttons">
        <a href="https://play.google.com/store/apps/details?id=il.co.betterway.app&hl=en" target="_blank" class="google-play">
          <img src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png" alt="Get it on Google Play" class="store-button" />
        </a>
        <a href="https://apps.apple.com/fi/app/better-way-%D7%91%D7%98%D7%A8-%D7%95%D7%95%D7%90%D7%99/id1479321867" target="_blank" class="app-store">
          <img src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1599091200" alt="Download on the App Store" class="store-button" />
        </a>
      </div>
    </div>
    
    <div class="what-we-do system">
      <h1>על המערכת</h1>
      <div>
        <strong>קיבלתם דוח? המערכת תבצע בדיקה אוטומטית של תקינותו ומהימנותו</strong>
        <ul>
          <li>התאמת מספר הרכב בדוח לרכבי החברה</li>
          <li>בדיקת כפילות דוחות על ידי פקחים שונים ו/או מצלמות רחוב</li>
          <li>התאמת מיקום הדוח למסלול הרכב</li>
        </ul>
      </div>
      <div>
        <strong>הדוח לא תקין?</strong>
        <p>המערכת תשלח לכם התרעה ותציע לכם דרך להגשת ערור.</p>
      </div>
      <div>
        <strong>הדוח תקין?</strong>
        <p>תוכלו להסדיר את התשלום באמצעות המערכת או להסב את התשלום לנהג ולהימנע מתשלומי פיגורים.</p>
      </div>
      <div>
        <strong>אירעה תאונה?</strong>
        <p>צילום תמונות באמצעות האפליקציה והזנת נתוני הרכב והנהג השני ידווחו מיידית לקצין הבטיחות בתעבורה להמשך טיפול.</p>
      </div>
      
      <div class="system-actions">
        <a href="https://app.betterway.co.il/" target="_blank" class="btn-primary">כניסה למערכת ציי רכב</a>
        <a href="/terms.html" target="_blank" class="link-secondary">תנאי שימוש במערכות BetterWay</a>
      </div>
    </div>
    <div class="contact">
      <div>
        <a href="mailto:shay@betterway.co.il">shay@betterway.co.il</a>
      </div>
      <div>
        <a href="phone:+97254.991.7091">054.991.7091</a>
      </div>
      <div>
        <a href="https://www.betterway.co.il">www.betterway.co.il</a>
      </div>
    </div>
  </div>
</template>

<script>
import DialogLegalAcceptance, { hasUserAcceptedLegal } from '@/components/DialogLegalAcceptance.vue';

export default {
  name: "home",
  components: { DialogLegalAcceptance },
  data() {
    return {
      showLegal: !hasUserAcceptedLegal(),
    };
  },
};
</script>
<style lang="less" scoped>
.home {
  background-color: #1e1e1e;
  padding: 60px;

  @media screen and (max-width: 600px) {
    padding: 20px;
  }

  .content {
    max-width: 1024px;
    margin: 0 auto;
  }
}
.intro {
  display: flex;
  flex-basis: 0;
  justify-content: center;
  align-content: center;
  margin-bottom: 50px;

  @media screen and (max-width: 600px) {
    flex-direction: column;
  }

  p {
    font-size: 14px;
    margin: 0;
    flex-grow: 1;
    max-width: 390px;
    text-align: right;
    margin: 0 60px;

    @media screen and (max-width: 600px) {
      margin: 10px 0;
      text-align: justify;
    }
  }
}
.what-we-do {
  border-top: 2px solid #515151;
  border-bottom: 2px solid #515151;

  h1 {
    color: #00a69c;
    font-size: 52px;
    font-weight: bold;
    margin: 10px;
    text-align: center;
  }
}
.items {
  margin-top: 50px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 100px;
  grid-row-gap: 50px;
  align-items: start;

  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
  }

  .item {
    display: flex;
    align-items: center;
    text-align: right;

    img {
      margin-left: 30px;
    }

    &:nth-child(1) {
      grid-column: 1;
      grid-row: 1;
    }
    &:nth-child(2) {
      grid-column: 2;
      grid-row: 1;
    }
    &:nth-child(3) {
      grid-column: 3;
      grid-row: 1;
    }
    &:nth-child(4) {
      grid-column: 1;
      grid-row: 2;
    }
    &:nth-child(5) {
      grid-column: 2;
      grid-row: 2;
    }
    &:nth-child(6) {
      grid-column: 3;
      grid-row: 2;
    }
    &:nth-child(7) {
      grid-column: 1;
      grid-row: 3;
    }
    &:nth-child(8) {
      grid-column: 2;
      grid-row: 3;
    }
    &:nth-child(9) {
      grid-column: 3;
      grid-row: 3;
    }

    @media screen and (max-width: 1024px) {
      grid-column: 1 !important;
      grid-row: auto !important;
    }
  }
}
.items-below {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 100px;
  margin-top: 50px;
  justify-items: end;

  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
    justify-items: center;
  }

  .item {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: right;

    img {
      margin-left: 30px;
    }
  }
}
.app-section {
  margin: 50px auto;
  max-width: 1024px;
  border-top: 2px solid #515151;

  @media screen and (max-width: 600px) {
    margin: 20px auto;
    padding: 30px 0;
  }

  h1 {
    color: #00a69c;
    font-size: 52px;
    font-weight: bold;
    text-align: center;
    margin: 0 0 40px 0;
    border-bottom: 2px solid #515151;

    @media screen and (max-width: 600px) {
      font-size: 36px;
      margin-bottom: 30px;
    }
  }

  .app-buttons {
    display: flex;
    justify-content: center;
    gap: 30px;
    align-items: stretch;

    @media screen and (max-width: 600px) {
      flex-direction: column;
      gap: 20px;
      align-items: center;
    }

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 70px;
      transition: transform 0.3s;

      @media screen and (max-width: 600px) {
        height: 60px;
      }

      &:hover {
        transform: scale(1.05);
      }

      &.google-play {
        .store-button {
          height: 145%;
        }
      }

      &.app-store {
        .store-button {
          height: 100%;
        }
      }
    }

    .store-button {
      width: auto;
      object-fit: contain;
      display: block;
    }
  }
}

.system {
  margin: 50px auto;
  background-image: url("/images/big gray logo.svg");
  background-repeat: no-repeat;
  max-width: 1024px;
  padding: 20px 0;
  padding-bottom: 40px;
  background-position-y: 50%;
  font-size: 14px;
  border-bottom: 2px solid #00a69c;

  @media screen and (max-width: 600px) {
    background-position-y: calc(100% - 20px);
    background-position-x: 50%;
    background-size: 60px;
    padding-bottom: 100px;
    margin: 20px auto;
  }

  h1 {
    text-align: center;
    margin-bottom: 30px;
  }
  div {
    margin: 20px 0;
  }
  p {
    margin: 0;
  }

  .system-actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    margin-top: 40px;

    .btn-primary {
      background-color: #00a69c;
      color: white;
      padding: 15px 40px;
      text-decoration: none;
      font-size: 16px;
      font-weight: bold;
      border-radius: 4px;
      transition: background-color 0.3s;
      display: inline-block;

      &:hover {
        background-color: #008c84;
      }

      @media screen and (max-width: 600px) {
        padding: 12px 30px;
        font-size: 14px;
      }
    }

    .link-secondary {
      color: white;
      text-decoration: underline;
      font-size: 14px;
      transition: opacity 0.3s;

      &:hover {
        opacity: 0.8;
      }
    }
  }
}
.contact {
  display: flex;
  font-size: 20px;
  flex-direction: row-reverse;
  max-width: 1024px;
  justify-content: center;
  margin: 0 auto;
  div {
    margin: 0 20px;

    @media screen and (max-width: 600px) {
      margin: 0 5px;
      font-size: 12px;
    }
  }
  a {
    color: inherit;
    text-decoration: none;
  }
}
</style>

